import React, { CSSProperties, useRef } from 'react';

import { focusFirstInvalidFormElement } from 'utils/focusFirstInvalidElement';
import { setCustomTimeout } from 'utils/setCustomTimeout';

type Props = {
  inline?: boolean;
  shouldFocusFirstInvalidInput?: boolean;
  onSubmit?(): void;
};

export const FormControlComponent: React.FC<Props> = (props) => {
  const { onSubmit, children, shouldFocusFirstInvalidInput, inline } = props;

  const formStyle: CSSProperties = React.useMemo(
    () => ({
      display: inline ? 'inline-block' : 'contents',
    }),
    [inline]
  );

  const formElementRef = useRef<HTMLFormElement>(null);

  const handleSubmit = React.useCallback(
    (event: React.SyntheticEvent) => {
      event.preventDefault();

      if (onSubmit) {
        onSubmit();
      }
    },
    [onSubmit]
  );

  React.useEffect(() => {
    const { current: formElement } = formElementRef;

    if (formElement && shouldFocusFirstInvalidInput) {
      // WARNING: без таймаута не фокусируется
      return setCustomTimeout(() => {
        focusFirstInvalidFormElement(formElement);
      }, 0);
    }
  }, [shouldFocusFirstInvalidInput]);

  return (
    <form
      noValidate
      ref={formElementRef}
      style={formStyle}
      onSubmit={handleSubmit}
    >
      {children}
    </form>
  );
};
